module.exports = __webpack_public_path__ + "img/nature-74.d68ea16c.jpg";